import * as z from "zod";

export const loginSchema = z.object({
  email: z
    .string()
    .nonempty({ message: "Email is required" })
    .email({ message: "Invalid email address" })
    .max(50, { message: "Email must not exceed 50 characters" }),
  rememberMe: z.boolean().optional(),
});

export const otpSchema = z.object({
  otp: z
    .string()
    .min(6, "Required")
    .regex(/^\d+$/, "OTP must contain only numbers"),
});

export type OTPFormValues = z.infer<typeof otpSchema>;

export type LoginFormSchema = z.infer<typeof loginSchema>;


